<template>
  <auth-modal
    v-if="isLazyLoaded"
    @hook:mounted="$_lazyLoadModal_onComponentMounted"
  />
</template>

<script>
import mixins from '@/utils/mixins'
import { MODAL } from '@/components/_modals/AModalWrapper/enums'

export default {
  name: 'AAuthModalLazyLoad',
  mixins: [mixins.lazyLoadModal(MODAL.AUTH)],
  components: {
    AuthModal: () => import('./index')
  }
}
</script>

<style lang="scss" scoped></style>
